export const domainIds = {
  tmn_tag: 'tmntag.js', 
  amp: 'amp',
  tmn_head: 'tmnhead.js', 
  ramp: 'ramp', 
  config: 'config'
};

const domains = [
  { id: domainIds.tmn_tag,       name: 'TMN Tag',       rtb_visible: true },
  { id: domainIds.ramp,          name: 'RAMP',           rtb_visible: true },
  { id: domainIds.amp,           name: 'AMP',            rtb_visible: true },
  { id: domainIds.tmn_head,      name: 'TMN Head',      rtb_visible: false },
  { id: domainIds.config,        name: 'Configuration',  rtb_visible: false }
];

export function domainsDropdown() {
  return domains.map(({rtb_visible, ...attributes}) => attributes)
}

export function rtbDomainsDropdown() {
  return domains
    .filter(function (e) {
      return e.rtb_visible;
    })
    .map(({rtb_visible, ...attributes}) => attributes)
}


// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/StaticData/Domains.tsx